import axios from 'axios';
import { CAP_ESIGN_URL_ENDPOINT } from '../constants/endpoint';
import { getAuthToken } from '../providers/authTokenProvider';

export const GetCapEsignUrl = async (documentId, documentType, customerSigned, contactId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
    },
  };

  const params = [`customerSigned=${customerSigned}`, `documentType=${documentType}`, `primaryContactId=${contactId}`, `srAttachmentId=${documentId}`];
  const response = await axios.get(`${CAP_ESIGN_URL_ENDPOINT}?${params.join('&')}`, null, config);
  return response;
};
